import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { decodeToken } from 'react-jwt'

//creating a type description interface
export interface AuthState {
    authData: {
        accessToken: string | null
        username: string | null
        partner: string | null
        partnername: string | null
        accesslevel: string | null
        error: string | null,
        currentPage: string | null,
        id: any,
        language: string | null
    }
}

export interface decodedToken {
    iat: number
    nbf: number
    exp: number
    iss: string
    aud: string
    sub: string
    username: string
    partner: any
    partnername: any
    accesslevel: string
    language: string
}

//The initial state is taken from localstorage, if there is none - null
const initialState: AuthState = {
    authData: {
        accessToken: localStorage.getItem('access_token') ? localStorage.getItem('access_token') : null,
        username: localStorage.getItem('username') ? localStorage.getItem('username') : null,
        language: localStorage.getItem('targetlanguage') ? localStorage.getItem('targetlanguage') : "en",
        partner: localStorage.getItem('partner') ? localStorage.getItem('partner') : null,
        partnername: null,
        accesslevel: localStorage.getItem('accesslevel') ? localStorage.getItem('accesslevel') : null,
        error: null,
        currentPage: 'Dashboard',
        id: localStorage.getItem('id') ? localStorage.getItem('id') : null
    }
}
const ClearState: AuthState = {
    authData: {
        accessToken: null,
        username: null,
        partner: null,
        partnername: null,
        accesslevel: null,
        error: null,
        currentPage: null,
        id: null,
        language: 'en'
    }
}

//Creating a slice with state interaction functions

export const authReducer = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginSuccess: (state, action: PayloadAction<string>): AuthState => {
            // decode once and normalize types (store accesslevel and id as strings)
            const token = action.payload ? decodeToken<decodedToken>(action.payload) : null
            return {
                ...state,
                authData: {
                    ...state.authData,
                    accessToken: action.payload,
                    username: token ? token.username : null,
                    partner: token ? token.partner : null,
                    partnername: token ? token.partnername : null,
                    // normalize to string so UI comparisons are consistent
                    accesslevel: token && token.accesslevel !== undefined && token.accesslevel !== null ? String(token.accesslevel) : null,
                    id: token && token.sub !== undefined && token.sub !== null ? String(token.sub) : null,
                    language: token && token.language ? String(token.language) : "en",
                    error: null,
                }
            }
        },
        ChangeLanguage: (state, action: PayloadAction<string>): AuthState => ({
            ...state,
            authData: {
                ...state.authData,
                language: action.payload
            }
        }),
        loginFailure: (state, action: PayloadAction<string>): AuthState => ({
            ...state,
            authData: {
                ...state.authData,
                error: action.payload,
            }
        }),
        logoutSuccess: (): AuthState => ClearState,
        setCurrentPage: (state, action: PayloadAction<string>): AuthState => ({
            ...state,
            authData: {
                ...state.authData,
                currentPage: action.payload,
            }
        }),
    },
})

export const { loginSuccess, loginFailure, logoutSuccess, setCurrentPage, ChangeLanguage } = authReducer.actions

export default authReducer.reducer